var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSmallBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 27.428,
    viewBox: "0 0 24 27.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_307",
    x: 1.643,
    y: 2.55,
    width: 19.695,
    height: 23.19,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fadd4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_308",
    x: 10.136,
    y: 0,
    width: 13.864,
    height: 17.237,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fadd4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_309",
    x: 0,
    y: 11.084,
    width: 12.79,
    height: 16.344,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fadd4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_206",
    "data-name": "Groupe 206",
    transform: "translate(909.594 -271.849)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -909.59, 271.85)",
    filter: "url(#Trac\\xE9_307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_307-2",
    "data-name": "Trac\\xE9 307",
    d: "M-850.5,344.243l-7.681,7.681-3.014-3.008,7.688-7.683Z",
    transform: "translate(867.33 -338.68)",
    fill: "#4fadd4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -909.59, 271.85)",
    filter: "url(#Trac\\xE9_308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_308-2",
    "data-name": "Trac\\xE9 308",
    d: "M-633.647,278.586l-3.045-3.045c.019-.021.046-.055.076-.085q.58-.581,1.16-1.16a1.35,1.35,0,0,1,2,0q.634.629,1.264,1.264a1.042,1.042,0,0,1,.006,1.569c-.461.465-.925.926-1.388,1.388C-633.6,278.542-633.626,278.567-633.647,278.586Z",
    transform: "translate(651.33 -273.85)",
    fill: "#4fadd4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -909.59, 271.85)",
    filter: "url(#Trac\\xE9_309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_309-2",
    "data-name": "Trac\\xE9 309",
    d: "M-903.833,566.812l3.028,3.024c-.287.071-.578.144-.869.215l-2.4.581c-.383.093-.583-.1-.5-.478Q-904.206,568.483-903.833,566.812Z",
    transform: "translate(909.09 -555.73)",
    fill: "#4fadd4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmallBlue);
export default __webpack_public_path__ + "static/media/edit-small-blue.00d6d57fe930fb378b1404409561d48a.svg";
export { ForwardRef as ReactComponent };